import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CButton,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogform,
	MyDialoglookup,
	MyDialoglookupapi,
	MyDialogformsubjective,
	MyDialogformobjective,
	MyDialognomorgigi,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import useSatusehat from '../../helpers/useSatusehat'

const pjson 		= require('../../../package.json')
const Rekammedisform 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	const { tabel_id } 			= useParams(); 
	const { loadTokensatusehat } 		= useSatusehat(props);
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const uRekammedisID				= parseInt(tabel_id)||0;

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const uLastinitObj 					= useSelector(state => state.gInitRMSelected);

	const uTokensatusehatObj			= JSON.parse(localStorage.getItem("tokensatusehat") || "{}");
	const [uDatamainObj,setDatamainObj]		= React.useState({})
	const [uDataanamnaseArr,setDataanamanseArr]	= React.useState([])
	const [uDatadiagnosaArr,setDatadiagnosaArr]	= React.useState([])
	const [uToggleditObj,setToggleditObj]	= React.useState({})
	const [uDataloading,setDataloading] 	= React.useState(false);
	const [uTriggeredit,setTriggeredit] = React.useState(false);

	//--DLG_FORMSUBJECTIVE--/
	const uDatasubjectiveObj 			= useSelector(state => state.gDatasubjective) || {};
	const uISDlgformsubjectivesimpan 	= useSelector(state => state.gISSubjectivesimpan) || false;
	const [uISDlgformsubjectiveshow,setDlgformsubjectiveshow]	= React.useState(false)
	//--END DLG_FORMSUBJECTIVE--/

	//--DLG_FORMOBJECTIVE--/
	const uDataobjectiveObj 			= useSelector(state => state.gDataobjective) || {};
	const uISDlgformobjectivesimpan 	= useSelector(state => state.gISObjectivesimpan) || false;
	const [uISDlgformobjectiveshow,setDlgformobjectiveshow]	= React.useState(false)
	//--END DLG_FORMOBJECTIVE--/

	//--DLG_FORM--/
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	//--END DLG_FORM--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	//---DLG_LOOKUP_API--/
	const [uISDlglookupapishow,setDlglookupapishow]	= React.useState(false)
	const [uDlglookupapiObj,setDlglookupapiObj]	= React.useState({})
	//---END DLG_LOOKUP_API--/

	//--DLG_PiLIHGIGI--/
	const [uISDlgnomorgigishow,setDlgnomorgigishow]	= React.useState(false);
	const [uDlgnomorgigiObj	,setDlgnomorgigiObj]	= React.useState({});
	//--END DLG_PiLIHGIGI--/

	//---HANDEL--/
	const hdlKlikBack = () => { uNavigate(-1); }
	const hdlKlikToggleeditmain = async(_JENIS,_IDITEM) => {
		_IDITEM		= parseInt(_IDITEM ?? "0");
		_JENIS		= _JENIS || "";
		setToggleditObj({});
		if(uToggleditObj.jenis === _JENIS 
			&& (parseInt(uToggleditObj.tabel_id)||0) === 0) {
			return;
		}

		let vValue;
		if(_JENIS === "DIAGNOSAMAIN") {
			vValue = parseInt(uDatamainObj.diagnosa_main_id) || 0;
		} else if(_JENIS === "DIAGNOSAMAINTEKS") {
			vValue = uDatamainObj.diagnosa_main_teks || "";
		} else if(_JENIS === "SUBJECTIVE") {
			vValue = uDatamainObj.subjective_str || "";
		} else if(_JENIS === "FORMOBJECTIVE") {
			vValue = uDatamainObj.objective_str || "";
		} else if(_JENIS === "OBJECTIVE") {
			vValue = uDatamainObj.objective_teks || "";
		}

		setToggleditObj({
			jenis: _JENIS,
			value: vValue,
		});

 		//--LANGSUNG_LOOKUP--/
		if(_JENIS === "DIAGNOSAMAIN"
			) {
			hdlKlikDiagnosalookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--/

		//--HAPUS_DIAGNOSA_SEKUNDER--/
		if(_JENIS === "DIAGNOSASEKUNDERHAPUS") {
			const vDiagnosasekunderArr	= JSON.parse(uDatamainObj.diagnosa_sekunder_str || "[]");
			const vIdxsekunder 			= UFunc.getObjectIndeks(vDiagnosasekunderArr,_IDITEM,"diagnosa_sekunder_id");
	
			if(await Konfirm("Diagnosa Sekunder <b>"+
					(vDiagnosasekunderArr[vIdxsekunder].diagnosa_sekunder_caption||"UNDF")+"</b> Akan Dihapus.."+
				"<br/>Apakah Anda Yakin ?"+
				"")) setTriggeredit(true);
			return;
		}
		//--END HAPUS_DIAGNOSA_SEKUNDER--/

		if(_JENIS === "SUBJECTIVE") {
			const vSubjectiveObj	= JSON.parse(vValue || "{}");
			if(!vSubjectiveObj.anamnase)
				vSubjectiveObj.anamnase_caption = uDatamainObj.anamnase;
			if(!vSubjectiveObj.anamnase_id)
				vSubjectiveObj.anamnase_id = uDatamainObj.anamnase_id;

			if((parseInt(uDatamainObj.anamnase_id)||0) <= 0) 
				vSubjectiveObj.anamnase_caption = undefined;

			//console.log("(Rekammedisform - hdlKlikToggleeditmain) uDatamainObj : "+JSON.stringify(uDatamainObj));
			//console.log("(Rekammedisform - hdlKlikToggleeditmain) uDatamainObj.anamnase_id : "+uDatamainObj.anamnase_id);
			uDispatch({type: "set", gDatasubjective: vSubjectiveObj});
			setDlgformsubjectiveshow(true);
		} else if(_JENIS === "FORMOBJECTIVE") {
			uDispatch({type: "set", gDataobjective: JSON.parse(vValue || "{}")});
			setDlgformobjectiveshow(true);
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus;
			if(_JENIS === "DIAGNOSAMAINTEKS")
				vElfocus	= document.getElementById("inpdiagnosaket");
			else if(_JENIS === "SUBJECTIVE")
				vElfocus	= document.getElementById("inpkeluhanutama");
			else if(_JENIS === "OBJECTIVE")
				vElfocus	= document.getElementById("inpobjectiveteks");
			else if(_JENIS === "FORMOBJECTIVE")
				vElfocus	= document.getElementById("inptekanandarahatas");

			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikToggleprosesmain = () => {
		setTriggeredit(true);
	}

	const hdlKlikToggleedititem = (_IDTABEL,_JENIS) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;
		_JENIS		= _JENIS || "";

		setToggleditObj({});
		if(uToggleditObj.jenis === _JENIS && uToggleditObj.tabel_id === _IDTABEL) {
			return;
		}

		const vArridx	= UFunc.getObjectIndeks((uDatamainObj.items_arr||[]),_IDTABEL);
		let vValue;
		if(_JENIS === "KETGIGI")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).nomorgigiarr_str || "[]").trim();
		else if(_JENIS === "DIAGNOSASEKUNDER")
			vValue		= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_id) || 0;
		else if(_JENIS === "TINDAKANTEKS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_teks || "").trim();
		else if(_JENIS === "TINDAKANCAPTION")
			vValue		= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_id) || 0;
		else if(_JENIS === "TINDAKANCAPTIONHAPUS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_caption || "").trim();
		else if(_JENIS === "DIAGNOSASEKUNDERHAPUS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_caption || "").trim();

		setToggleditObj({
			tabel_id : _IDTABEL,
			jenis: _JENIS,
			value: vValue,
		});

		//--LANGSUNG_HAPUS--/
		if(_JENIS === "TINDAKANCAPTIONHAPUS") {
			hdlKlikTindakanhapus();
			return;
		}
		//--END LANGSUNG_HAPUS--/

		//--LANGSUNG_HAPUS--/
		if(_JENIS === "DIAGNOSASEKUNDERHAPUS") {
			hdlKlikDiagnosasekunderhapus();
			return;
		}
		//--END LANGSUNG_HAPUS--/

		//--LANGSUNGHAPUS--/
		if(_JENIS === "KETGIGIHAPUS") {
			hdlKlikNogigihapus();
			return;
		}
		//--END LANGSUNGHAPUS--/

		//--LANGSUNG_LOOKUP--/
		if(_JENIS === "TINDAKANCAPTION") {
			hdlKlikTindakanlookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--/

		//--LANGSUNG_LOOKUP--/
		if(_JENIS === "DIAGNOSASEKUNDER") {
			hdlKlikDiagnosalookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--/

		//--LANGSUNG_FORM--/
		if(_JENIS === "KETGIGI") {
			setDlgnomorgigiObj({
				nomorgigi_arr: JSON.parse(vValue || "[]"),
				tabel_id: _IDTABEL,
			});
			setDlgnomorgigishow(true);
			return;
		}
		//--END LANGSUNG_FORM--/

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus;
			if(_JENIS === "TINDAKANTEKS")
				vElfocus	= document.getElementById("inptindakan_teks");

			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKDownToggleedititem = (_IDTABEL,_EV) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;

		if(_EV.keyCode === 27) {
			setToggleditObj({}); return;
		}

		if(_EV.keyCode === 13) {
			if (_EV.target.nodeName === "TEXTAREA") {
				if(_EV.shiftKey) return;
			}

			_EV.stopPropagation();
			_EV.preventDefault();
			hdlKlikToggleprosesitem();
			return;
		}
	}
	const hdlKlikNomorgigipilih = (_IDGIGI) => {
		_IDGIGI = (_IDGIGI||"").trim();
		const vArridx 		= parseInt(uDlgnomorgigiObj.tabel_id ?? "0");

		let vKetgigilabel	= "";
		let vNomorgigiArr	= uDlgnomorgigiObj.nomorgigi_arr||[];
		const vArrgigiall 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 11 && vItems <= 18) ||
				(vItems >= 21 && vItems <= 28) ||
				(vItems >= 31 && vItems <= 38) ||
				(vItems >= 41 && vItems <= 48) ||
				(vItems >= 51 && vItems <= 55) ||
				(vItems >= 61 && vItems <= 65) ||
				(vItems >= 71 && vItems <= 75) ||
				(vItems >= 81 && vItems <= 85)
			).map(vItems=>(vItems||"").toString());

		const vArrMaxilla 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 11 && vItems <= 18) ||
				(vItems >= 21 && vItems <= 28) ||
				(vItems >= 51 && vItems <= 55) ||
				(vItems >= 61 && vItems <= 65)
			).map(vItems=>(vItems||"").toString());

		const vArrMandibula 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 31 && vItems <= 38) ||
				(vItems >= 41 && vItems <= 48) ||
				(vItems >= 71 && vItems <= 75) ||
				(vItems >= 81 && vItems <= 85)
			).map(vItems=>(vItems||"").toString());

		if(_IDGIGI === "_ALL_") {
			if(vNomorgigiArr.length === vArrgigiall.length) {
				vKetgigilabel	= "";
				vNomorgigiArr	= [];
			} else {
				vKetgigilabel	= "SEMUA GIGI";
				vNomorgigiArr	= vArrgigiall;
			}
		} else if(_IDGIGI === "_CLEAR_") {
			vKetgigilabel	= "";
			vNomorgigiArr	= [];
		} else if(_IDGIGI === "_MAXILLA_") {
			if (vNomorgigiArr.length !== vArrMaxilla.length) {
				vNomorgigiArr = vArrMaxilla;
				vKetgigilabel	= "REGIO MAXILLA (ATAS)";
			} else {
				const sorted1 = [...vNomorgigiArr].sort(UFunc.customSort);
				const sorted2 = [...vArrMaxilla].sort(UFunc.customSort);

				const vISMaxillachecked = sorted1.every((val, index) => val === sorted2[index]);

				if(vISMaxillachecked) {
					vKetgigilabel	= "";
					vNomorgigiArr	= [];
				} else {
					vNomorgigiArr = vArrMaxilla;
					vKetgigilabel= "REGIO MAXILLA (ATAS)";
				}
			}
		} else if(_IDGIGI === "_MANDIBULA_") {
			if (vNomorgigiArr.length !== vArrMandibula.length) {
				vNomorgigiArr 	= vArrMandibula;
				vKetgigilabel	= "REGIO MANDIBULA (BAWAH)";
			} else {
				const sorted1 = [...vNomorgigiArr].sort(UFunc.customSort);
				const sorted2 = [...vArrMandibula].sort(UFunc.customSort);

				const vISMandibulachecked = sorted1.every((val, index) => val === sorted2[index]);

				if(vISMandibulachecked) {
					vKetgigilabel	= "";
					vNomorgigiArr	= [];
				} else {
					vNomorgigiArr = vArrMandibula;
					vKetgigilabel= "REGIO MANDIBULA (BAWAH)";
				}
			}
		} else if(_IDGIGI === "PARAMOLARKW1"
			|| _IDGIGI === "PARAMOLARKW2"
			|| _IDGIGI === "PARAMOLARKW3"
			|| _IDGIGI === "PARAMOLARKW4"
		) {
			const vNamagigi		= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNamagigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else {
				if (vNomorgigiArr.length > 1
				) {
					vNomorgigiArr	= [vNamagigi];
				} else {
					vNomorgigiArr	= [...vNomorgigiArr,vNamagigi];
				}

				vKetgigilabel = vNomorgigiArr.map(vItems=>{
					if(vItems==="PARAMOLARKW1"
						|| vItems==="PARAMOLARKW2"
						|| vItems==="PARAMOLARKW3"
						|| vItems==="PARAMOLARKW4"
						) return "PARAMOLAR";
					if(vItems==="MESIODENATAS"
						|| vItems==="MESIODENBAWAH"
						) return "MESIODEN";

					return "No-"+vItems;
				}).join(", ");
			}
		} else if(_IDGIGI === "MESIODENATAS"
			|| _IDGIGI === "MESIODENBAWAH"
		) {
			const vNamagigi		= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNamagigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else {
				if (vNomorgigiArr.length > 7
				) {
					vNomorgigiArr	= [vNamagigi];
				} else {
					vNomorgigiArr	= [...vNomorgigiArr,vNamagigi];
				}

				vKetgigilabel = vNomorgigiArr.map(vItems=>{
					if(vItems==="PARAMOLARKW1"
						|| vItems==="PARAMOLARKW2"
						|| vItems==="PARAMOLARKW3"
						|| vItems==="PARAMOLARKW4"
						) return "PARAMOLAR";
					if(vItems==="MESIODENATAS"
						|| vItems==="MESIODENBAWAH"
						) return "MESIODEN";

					return "No-"+vItems;
				}).join(", ");
			}
		} else {
			const vNomorgigi	= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNomorgigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else vNomorgigiArr	= [...vNomorgigiArr,vNomorgigi];

			//vKetgigilabel = vNomorgigiArr.map(vItems=>"No-"+vItems).join(", ");
				
			vKetgigilabel = vNomorgigiArr.map(vItems=>{
				if(vItems==="PARAMOLARKW1"
					|| vItems==="PARAMOLARKW2"
					|| vItems==="PARAMOLARKW3"
					|| vItems==="PARAMOLARKW4"
					) return "PARAMOLAR";
				if(vItems==="MESIODENATAS"
					|| vItems==="MESIODENBAWAH"
					) return "MESIODEN";

				return "No-"+vItems;
			}).join(", ");
		}
		//console.log("(Rekammedisform - hdlKlikNomorgigipilih) uToggleditObj",uToggleditObj);
		//console.log("(Rekammedisform - hdlKlikNomorgigipilih) vNomorgigiArr",vNomorgigiArr);
		//console.log("(Rekammedisform - hdlKlikNomorgigipilih) vKetgigilabel",vKetgigilabel);

		setToggleditObj({...uToggleditObj,
			value: JSON.stringify(vNomorgigiArr),
			ket_gigi: vKetgigilabel,
		});

		/*setDlgnomorgigiObj({...uDlgnomorgigiObj,
			nomorgigi_arr: vNomorgigiArr,
		});//-*/

		setTriggeredit(true);
	}
	const hdlKlikToggleprosesitem = () => {
		apiProsesedititem();
	}

	const hdlKlikToggleeditresep = (_JENIS,_IDXKEY) => {
		_IDXKEY = parseInt(_IDXKEY ?? "-1");
		_JENIS	= (_JENIS || "").trim();

		setToggleditObj({});
		if(uToggleditObj.jenis === _JENIS && uToggleditObj.idxkey === _IDXKEY) {
			return;
		}

		let vTmpObj;
		let vDataObj = (JSON.parse(uDatamainObj.reseparr_str||"[]"))[_IDXKEY] || {};
		if(_JENIS ==="RESEPQTY") {
			vTmpObj = { value: parseFloat(vDataObj.qty ?? "0")}
		} else if(_JENIS ==="RESEPKETENTUAN") {
			vTmpObj = { 
				frekuensi: parseInt(vDataObj.frekuensi ?? "0"),
				dosis: parseInt(vDataObj.dosis ?? "0"),
			}
		} else if(_JENIS ==="RESEPATURAN") {
			vTmpObj = { value: vDataObj.aturan || ""}
		}

		setToggleditObj({
			idxkey : _IDXKEY,
			jenis: _JENIS,
			...vTmpObj,
		});

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus;
			if(_JENIS === "RESEPQTY")
				vElfocus	= document.getElementById("inpresepqty");
			else if(_JENIS === "RESEPKETENTUAN")
				vElfocus	= document.getElementById("inpresepfrekuensi");
			else if(_JENIS === "RESEPATURAN")
				vElfocus	= document.getElementById("inpresepaturan");

			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikToggleprosesresep = () => {
		//--VALIDASI--/
		let vElfocus;
		if(uToggleditObj.jenis === "RESEPQTY") {
			vElfocus	= document.getElementById("inpresepqty");
			if(parseFloat(uToggleditObj.value ?? "0") < 1) {
				showToast("QTY Obat Tidak Valid !");
				return;
			}
		} else if(uToggleditObj.jenis === "RESEPKETENTUAN") {
			vElfocus	= document.getElementById("inpresepfrekuensi");
			if(parseInt(uToggleditObj.frekuensi ?? "0") < 1) {
				showToast("Frekuensi Obat Tidak Valid !");
				return;
			}

			vElfocus	= document.getElementById("inpresepdosis");
			if(parseFloat(uToggleditObj.dosis ?? "0") < 1) {
				showToast("Jml Dosis Obat Tidak Valid !");
				return;
			}
		}
		//--END VALIDASI--/

		apiProseseditresep()
	}
	const hdlKlikResephapus = async(_IDXKEY) => {
		_IDXKEY = parseInt(_IDXKEY ?? "-1");

		if(await Konfirm("<p><b>Data Resep Akan Dihapus</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) {
			setToggleditObj({
				jenis: "RESEPHAPUS",
				idxkey: _IDXKEY,
			});

			setTriggeredit(true);
			//hdlKlikToggleprosesresep();
		}
	}
	const hdlKlikMobileedit = (_IDTABEL) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;if(_IDTABEL <= 0) return;
		setToggleditObj({});

		const vDataitemsArr	= uDatamainObj.items_arr||[];
		const vArridx		= UFunc.getObjectIndeks(vDataitemsArr,_IDTABEL);
		const vCaptionupper	= ((vDataitemsArr[vArridx]||{}).caption_terapi||"").toUpperCase();

		setDlgformObj({
			dlg_header: "Edit: "+vCaptionupper,
			tabel_id: _IDTABEL,
			tindakan_id: parseInt((vDataitemsArr[vArridx]||{}).tindakan_id)||0,
			tindakan_caption: (vDataitemsArr[vArridx]||{}).tindakan_caption || "",
			ket_gigi: (vDataitemsArr[vArridx]||{}).ket_gigi || "",
			tindakan_teks: (vDataitemsArr[vArridx]||{}).tindakan_teks || "",
		})
		setDlgformshow(true);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(!isMobile)
				document.getElementById("inpdiagnosacaption") &&
					document.getElementById("inpdiagnosacaption").focus();
		},350)
	}
	const hdlKlikDiagnosalookup = () => {
		//--LOOKUP--/
		const vDatalookupArr = uDatadiagnosaArr.map(vItems =>{ 
			return {id: vItems.id,caption:vItems.nama_diagnosa} 
		})

		uDlglookupObj.lookup_arr 	= vDatalookupArr;
		uDlglookupObj.dlg_header	= ((uBahasaObj.word_lookup||"Lookup")+": "+
			(uBahasaObj.caption_datadiagnosa||"Data Diagnosa"))

		uDlglookupObj.inputvalue 	= "";
		uDlglookupObj.jenislookup 	= uToggleditObj.jenis;
		setDlglookupshow(true)
		//--END LOOKUP--/
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return

		//--JIKA_DESKTOP--/
		if(uToggleditObj.jenis === "DIAGNOSAMAIN"
			&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
			) {
			setToggleditObj({...uToggleditObj,value: _IDITEM});

			setTriggeredit(true);
			setDlglookupObj({...uDlglookupObj,init_selected:true})
			setDlglookupshow(false);
			return;
		} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
			&& (parseInt(uToggleditObj.tabel_id)||0) > 0
			) {

			const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
			setToggleditObj({...uToggleditObj,
				value: _IDITEM,
				value_caption: (uDatadiagnosaArr[vArridx]||{}).nama_diagnosa || "Undf Diagnosa",
			});

			setTriggeredit(true);
			setDlglookupObj({...uDlglookupObj,init_selected:true})
			setDlglookupshow(false);
			return;
		}
		//--END JIKA_DESKTOP--/

		//--JIKA_MOBILE--/
		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
		setDlgformObj({...uDlgformObj,
			diagnosa_main_id: _IDITEM,
			diagnosa_main: (uDatadiagnosaArr[vArridx]||{}).nama_diagnosa || "Undf Diagnosa",
		});
		setDlglookupshow(false);		
		//--END JIKA_MOBILE--/
	}
	const hdlKlikTindakanlookup = () => {
		setDlglookupapiObj({
			...uDlglookupapiObj,
			dlg_header: "Lookup: TINDAKAN ICD-9 CM",
			dlg_keyword: "",
			dlg_jenis: "TINDAKANCAPTION",
			dlg_targetapi: pjson.homepage+"api/api_dataicd9/ld_lookup",
		});

		setDlglookupapishow(true);
	}
	const hdlKlikPilihLookupapi = (_SELECTEDSTR) => {
		_SELECTEDSTR 	= _SELECTEDSTR||"{}";
		
		const vLookupObj= JSON.parse(_SELECTEDSTR);
		if(vLookupObj==={}) return;

		let vElfocus;
		if(uDlglookupapiObj.dlg_jenis === "TINDAKANCAPTION") {
			//console.log("vLookupObj = "+JSON.stringify(vLookupObj));

			setToggleditObj({...uToggleditObj,
				value: vLookupObj.id,
				value_caption: vLookupObj.caption
			});

			setTriggeredit(true);
			setDlglookupapiObj({...uDlglookupapiObj,init_selected:true})
			setDlglookupapishow(false);
			return;
		}

		setDlglookupapiObj({...uDlglookupapiObj,init_selected:true})
		setDlglookupapishow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikTindakanhapus = async() => {
		if(await Konfirm(
			"<p><b>Anda Akan MENGHAPUS Tindakan ICD-9</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) setTriggeredit(true);
	}
	const hdlKlikDiagnosasekunderhapus = async() => {
		if(await Konfirm(
			"<p><b>Anda Akan MENGHAPUS Diagnosa Sekunder</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) setTriggeredit(true);
	}
	const hdlKlikNogigihapus = async() => {
		if(await Konfirm(
			"<p><b>Anda Akan MENGHAPUS Nomor Gigi</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) setTriggeredit(true);
	}
	const hdlKlikDlgformsimpan = () => {
		//--VALIDASI--/
		//--END VALIDASI--/

		apiProsesedititem()
	}
	const hdlKlikKirimsatusehat = async() => {
		if((uDatamainObj.satusehat_status||"BELUM")==="SUDAH") {
			showToast(
				"<p class='fw-bolder'>Integrasi Satusehat Sudah Pernah Dilakukan</p>"+
				"<p>Mohon Dicek Kembali, Karena Proses Hanya Dapat Dilakukan SATU kali!</p>"+
				"")
			return;
		}

		if((parseInt(uDatamainObj.id_progress)||0) <= 0) {
			showToast(
				"<p class='fw-bolder'>Data Kunjungan Tidak Valid..</p>"+
				"<p>Kemungkinan Rekam Medis Merupakan Data Lama, Sehingga Data Progress Kunjungan Belum Tercatat!</p>"+
				"")
			return;
		}

		if(await Konfirm("<p><b>Kirim Data ke Server SATUSEHAT</b>..</p>"+
			"<small class='fst-italic'>"+
			"<p>Data Pemeriksaan Pasien Akan Dikirim ke SATUSEHAT. Proses Ini Hanya Dapat Dilakukan SEKALI.</p>"+
			"<p>Proses Tidak Dapat DIULANGI ataupun DIBATALKAN.</p>"+
			"</small>"+
			"Apakah Anda Yakin ?"+
			"")) apiKirimsatusehat();
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMobile = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard mb-3">
			<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
				<small>Data RM</small>
			</CCardHeader>
			
			<CCardBody>
				<div className="d-flex justify-content-between my-1">
				<small className="pe-1">Tgl Periksa</small>

				<div className="text-end fw-bolder">{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="pe-1">Dokter</small>
				<div className="text-end fw-bolder text-primary">
					{uDatamainObj.dokter_caption || "-"}
				</div>
				</div>
			</CCardBody>
		</CCard>
		)//->
	}
	const contentTanggal = () => {
		if(uHtml500msg) return "";

		return (
		<center>
			<b>{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</b>
		</center>
		)//>
	}
	const contentDokter = () => {
		if(uHtml500msg) return "";

		return (
		<div className="text-center fw-bolder text-primary">
			{uDatamainObj.dokter_caption || "-"}
		</div>
		)//>
	}
	const contentPerawat = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		return (
		<>
			<div className="fst-italic">
			{(uDatamainObj.perawat_arr||[]).length <= 0 ? (
				<small className="text-muted">&middot; Belum Ada Perawat &middot;</small>
			) : (
			<>
				{(uDatamainObj.perawat_arr||[]).map((vItems,vKeys)=>{
					return (
					<React.Fragment key={vKeys}>
						{(vKeys > 0) && (<> &middot; </>)}

						<b>{vItems.nama_perawat || "Undf Perawat"}</b>
					</React.Fragment>
					);
				})}
			</>
			)}
			</div>

			<div className="my-2 classborderbottom"/>

			<CTooltip className="d-none d-lg-block" content="--Edit Perawat">
			<CLink onClick={()=>hdlKlikToggleeditmain('PERAWAT')} className="classcursorpointer">
				<CIcon icon="cilPencil" className="classikonbox" height={28}/>
			</CLink>
			</CTooltip>
		</>
		)//>
	}
	const contentSubjective = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		return (
		<>
		<div className="fst-italic">
			{uDatamainObj.anamnase || "-"}
		</div>

		{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
		<>
			<div className="my-2 classborderbottom"/>

			<CTooltip className="d-none d-lg-block" content="--Edit Subjective">
			<CLink onClick={()=>hdlKlikToggleeditmain('SUBJECTIVE')} className="classcursorpointer">
				<CImage src={pjson.homepage+"api2/images/menus_anamnesa.png"} className="classikonbox" height={28}/>
			</CLink>
			</CTooltip>
		</>
		)}
		</>
		)//>
	}
	const contentObjective = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		const vObjectiveObj		= JSON.parse(uDatamainObj.objective_str ?? "{}");

		return (
		<>
		<div className="d-flex justify-content-between">
			{(uToggleditObj.jenis === "OBJECTIVE") ? (
			<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={100}
					value={uToggleditObj.value}
					onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
					onKeyDown={(e)=>{
						if(e.keyCode === 27) 
							{ setToggleditObj({}); return; }
						if(e.keyCode !== 13) return;

						e.preventDefault();e.stopPropagation();
						hdlKlikToggleprosesmain();
					}}
					id="inpobjectiveteks"/>
				<CInputGroupText className="bg-dark">
					<CLink onClick={()=>hdlKlikToggleprosesmain()} className="classcursorpointer text-white">
						<CIcon icon="cilCheck"/>
					</CLink>
				</CInputGroupText>
			</CInputGroup>
			) : (
			<>
				<div className="pe-1 fst-italic">
					{(uDatamainObj.objective_teks||"").trim() === "" ? (
						<small className="text-muted">&middot;Belum Ada Objective&middot;</small>
					) : (
						<>{uDatamainObj.objective_teks}</>
					)}
				</div>

				<CTooltip className="d-none d-lg-block" content="--Edit Objective">
				<CLink onClick={()=>hdlKlikToggleeditmain('OBJECTIVE')} className="classcursorpointer">
					<CIcon icon="cilPencil" className="classikonbox" height={23}/>
				</CLink>
				</CTooltip>
			</>
			)}
		</div>

		{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
		<>
			<div className="my-2 classborderbottom"/>

			<CTooltip className="d-none d-lg-block" content="--Edit Screening Awal">
			<CLink onClick={()=>hdlKlikToggleeditmain('FORMOBJECTIVE')} className="classcursorpointer">
				<CImage src={pjson.homepage+"api2/images/icon_objective.png"} className="classikonbox" height={28}/>
			</CLink>
			</CTooltip>
		</>
		)}
		</>
		)//>
	}
	const contentDiagnosamain = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		return (
		<>
		<div className="d-none">{JSON.stringify(uToggleditObj)}</div>
		<div>

			<div className="d-flex justify-content-between">
			{(uToggleditObj.jenis === "DIAGNOSAMAIN" 
				&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
				&& (uToggleditObj.is_processing||false)===true
			) ? (
				<CSpinner size="sm" color="primary"/>
			) : (
			<>
				<div className="pe-1">
					<div>{uDatamainObj.diagnosa_main ?? (<small className="text-muted">&middot;Diagnosa Empty&middot;</small>)}</div>
					<i className="classfontsmaller d-block">
						<small>Diagnosa Utama ICD-10</small>
					</i>
				</div>

				{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
				<CLink onClick={()=>hdlKlikToggleeditmain('DIAGNOSAMAIN')} className="classcursorpointer ps-2">
					<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
				</CLink>
				)}
			</>
			)}
			</div>
		</div>

		<div className="my-2 classborderbottom"/>

		<div className="d-flex justify-content-between">
			{(uToggleditObj.jenis === "DIAGNOSAMAINTEKS" 
				&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
			) ? (
			<>
				{(uToggleditObj.is_processing||false)===true ? (
					<CSpinner size="sm" color="primary"/>
				) : (
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={100}
					placeholder="--Keterangan Assessment.."
					value={uToggleditObj.value}
					onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
					onKeyDown={(e)=>{
						if(e.keyCode === 27) {
							setToggleditObj({}); return;
						}

						if(e.keyCode !== 13) return;

						e.stopPropagation();e.preventDefault();
						hdlKlikToggleprosesmain();
					}}
					id="inpdiagnosaket"/>
				<CInputGroupText className="bg-dark">
					<CLink onClick={()=>hdlKlikToggleprosesmain()} className="classcursorpointer text-white">
					<CIcon icon="cilCheck"/>
					</CLink>
				</CInputGroupText>
				</CInputGroup>
				)}
			</>
			) : (
			<>
				<div className="pe-1">
				{(uDatamainObj.diagnosa_main_teks||"").trim() === "" ? (
					<small className="fst-italic text-muted">&middot;Keterangan Assessment&middot;</small>
				) : (
					<i>{uDatamainObj.diagnosa_main_teks}</i>
				)}
				</div>

				<CLink onClick={()=>hdlKlikToggleeditmain('DIAGNOSAMAINTEKS')} className="classcursorpointer ps-2">
				<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
				</CLink>
			</>
			)}
		</div>
		</>
		)//>
	}
	const contentItem = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";//>

		const vDataitemsArr	= uDatamainObj.items_arr || [];

		if(vDataitemsArr.length <= 0) return (
			<CCard className="classbgcard mb-3">
				<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
					<small>Data RM</small>
				</CCardHeader>
				<CCardBody className="fst-italic text-center">&middot;&middot; Data Terapi Tidak Ada &middot;&middot;</CCardBody>
			</CCard>
		)

		return (
		<CForm>
		{vDataitemsArr.map((vItems,vKeys)=> {
			const {
				caption_terapi,tarif_terapi,tindakan_id,tindakan_caption,
				tindakan_teks,ket_gigi,qty,diagnosa_caption,diagnosa_id,
				id
			} = vItems;

			return (
			<CCard key={vKeys} className="classbgcard mb-3">
				<CCardHeader className="d-flex px-1">
					<span className="text-end" style={{width:25}}>{vKeys+1}.</span>
					
					<div>
					<div className="d-flex justify-content-between">
						<div className="px-1">
						<b className="text-uppercase">{caption_terapi}</b>
						<small className="d-none d-md-inline">
							<span> &middot; </span>
							(
							<b className="text-primary">{UFunc.formatAngka(qty)}</b> UNT
							<span> x </span>
							Rp<b className="text-success">{UFunc.formatAngka(tarif_terapi)}</b>
							)

							<span> &middot; </span>

							<b>{UFunc.formatAngka(parseFloat(tarif_terapi) * parseFloat(qty))}</b>
						</small>
						</div>

						<CLink onClick={()=>hdlKlikMobileedit(id)} className="mx-0 classcursorpointer classikon classikonedit d-md-none"/>
					</div>
					</div>
				</CCardHeader>

				<CCardBody>
				<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"23%"}}>Diagnosa Sekunder</small>

					{((uToggleditObj.jenis === "DIAGNOSASEKUNDER" || uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS") 
						&& uToggleditObj.tabel_id === parseInt(id)
						&& (uToggleditObj.is_processing||false) === true 
					) ? (
						<CSpinner size="sm" color="primary"/>
					) : (
					<>
						<div className="text-end text-capitalize" style={{width:"65%"}}>{diagnosa_caption || "-"}</div>

						{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
						<div className="text-end">
							{(parseInt(diagnosa_id)||0) > 0 && (
							<CLink onClick={()=>hdlKlikToggleedititem(id,"DIAGNOSASEKUNDERHAPUS")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilX" className="classikonbox mx-0 text-danger" height={20}/>
							</CLink>
							)}

							<CLink onClick={()=>hdlKlikToggleedititem(id,"DIAGNOSASEKUNDER")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
							</CLink>
						</div>
						)}
					</>
					)}
				</div>

				<div className="classborderbottom my-2"/>

				<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"23%"}}>Tindakan ICD-9 CM</small>

					{((uToggleditObj.jenis === "TINDAKANCAPTION" || uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS") 
						&& uToggleditObj.tabel_id === parseInt(id)
						&& (uToggleditObj.is_processing||false) === true 
					) ? (
						<CSpinner size="sm" color="primary"/>
					) : (
					<>
						<div className="text-end text-capitalize" style={{width:"65%"}}>{tindakan_caption || "-"}</div>

						{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
						<div className="text-end">
							{parseInt(tindakan_id ?? "0") > 0 && (
							<CLink onClick={()=>hdlKlikToggleedititem(id,"TINDAKANCAPTIONHAPUS")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilX" className="classikonbox mx-0 text-danger" height={20}/>
							</CLink>
							)}

							<CLink onClick={()=>hdlKlikToggleedititem(id,"TINDAKANCAPTION")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
							</CLink>
						</div>
						)}
					</>
					)}
				</div>

				<div className="classborderbottom my-2"/>

				<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"23%"}}>Nomor Gigi</small>

					{((uToggleditObj.jenis === "KETGIGI" 
						|| uToggleditObj.jenis === "KETGIGIHAPUS"
					) && uToggleditObj.tabel_id === parseInt(id)
						&& (uToggleditObj.is_processing||false) === true 
					) ? (
						<CSpinner size="sm" color="primary"/>
					) : (
					<>
						<div className="text-end" style={{width:"65%"}}>{ket_gigi || "-"}</div>

						<div className="text-end">
							{(ket_gigi||"").trim() !== "" && (
							<CLink onClick={()=>hdlKlikToggleedititem(id,"KETGIGIHAPUS")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilX" className="classikonbox mx-0 text-danger" height={20}/>
							</CLink>
							)}

							<CLink onClick={()=>hdlKlikToggleedititem(id,"KETGIGI")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
							</CLink>
						</div>
					</>
					)}
				</div>

				<div className="classborderbottom my-2"/>
					
				<div className="d-flex justify-content-between">
					<small className="pe-1 d-block" style={{color:"maroon"}}>Keterangan Tindakan</small>
					
					{(uToggleditObj.jenis === "TINDAKANTEKS" && uToggleditObj.tabel_id === parseInt(id)) ? (
					<div className="w-75" style={{minWidth:200}}>
						{(uToggleditObj.is_processing||false) === false ? (
						<>
						<CInputGroup size="sm" className="align-items-start">
						<CFormTextarea size="sm"
							rows={7}
							className="h-100" 
							value={UFunc.br2nl(uToggleditObj.value||"")}
							onKeyDown={(e)=>hdlKDownToggleedititem(id,e)}
							onChange={(e)=>setToggleditObj({...uToggleditObj,value:UFunc.nl2br(e.target.value)})}
							id="inptindakan_teks"/>
						<CButton size="sm" color="dark" onClick={()=>hdlKlikToggleprosesitem()}>
						<CIcon icon="cilCheck"/>
						</CButton>
						</CInputGroup>
						<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea}</div>
						</>
						) : (
						<center><CSpinner size="sm" color="primary"/></center>
						)}
					</div>
					) : (						
					<>
						<div className="d-md-none fst-italic">{UFunc.renderHTML(tindakan_teks || "-")}</div>
						
						<div style={{width:"75%"}} className="text-end d-none d-md-block fst-italic">
							{UFunc.renderHTML(tindakan_teks || "-")}
						</div>
						
						<CLink onClick={()=>hdlKlikToggleedititem(id,"TINDAKANTEKS")} className="classcursorpointer ps-2 d-none d-md-block">
						<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
						</CLink>
					</>
					)}
				</div>
				</CCardBody>
			</CCard>
			)//->
		})}
		</CForm>
		)//>
	}
	const contentResep = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		const vResepArr	= JSON.parse(uDatamainObj.reseparr_str || "[]");

		if(vResepArr.length <= 0) return (
		<div className="py-5 text-center">
			<small className="fst-italic text-muted">
			&middot;Resep Obat Tidak Ada&middot;
			</small>
		</div>
		)//>

		const vISstatusselesai	= (uDatamainObj.selesai_status||"YA")==="YA";

		return (
		<table className="table table-borderless table-hover" id="idtabelresep">
		<thead>
			<tr className="p-0 classborderbottom">
			<th width={30} className="p-0"/>
			<th className="p-0"/>
			{(uDatamainObj.selesai_status||"YA")==="TIDAK" && (
			<th width={50} className="p-0"/>
			)}
			</tr>
		</thead>

		<tbody>
		{vResepArr.map((vItems,vKeys)=>{
			return (
			<tr className="align-top classborderbottom" key={vKeys}>
			<td className="px-1 text-end">{vKeys+1}.</td>
			
			<td className="px-1 text-start">
				<div className="fw-bolder">
					{vItems.kfa_code||"Undf Code"}
					<span> </span>
					{vItems.caption_display||"Undf Item"}
				</div>

				<div className="my-2 classborderbottom"/>

				<div style={{minWidth:180,width:"90%"}} className="d-flex justify-content-between">
					<small>Jumlah</small>

					{vISstatusselesai ? (
					<div className="text-end">
						<b>{vItems.qty}</b> {vItems.satuan_kecil||"pcs"}
					</div>
					) : (
					<div style={{minWidth:70,width:"35%"}} className="text-end">
						{(uToggleditObj.jenis === "RESEPQTY" 
							&& parseInt(uToggleditObj.idxkey ?? "-1") === vKeys
						) ? (
						<>
							{(uToggleditObj.is_processing||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CInputGroup size="sm">
								<CFormInput size="sm" type="number"
									className="text-end"
									value={uToggleditObj.value}
									onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
									onKeyDown={(e)=>{
										if(e.keyCode === 27) {
											setToggleditObj({}); return;
										}

										if(e.keyCode !== 13) return;

										e.stopPropagation();e.preventDefault();
										hdlKlikToggleprosesresep();
									}}
									onFocus={(e)=>e.target.select()}
									id="inpresepqty"/>
								<CInputGroupText className="bg-dark">
									<CLink onClick={()=>hdlKlikToggleprosesresep()} className="classcursorpointer text-white">
									<CIcon icon="cilCheck"/>
									</CLink>
								</CInputGroupText>
							</CInputGroup>
							)}
						</>
						) : (
						<CLink onClick={()=>hdlKlikToggleeditresep('RESEPQTY',vKeys)} className="classcursorpointer ps-2">
							<b>{vItems.qty}</b> {vItems.satuan_kecil||"pcs"}
						</CLink>
						)}
					</div>
					)}
				</div>

				<div style={{minWidth:180,width:"90%"}} className="d-flex justify-content-between">
					<small>Ketentuan</small>

					{vISstatusselesai ? (
					<small className="text-end">
						<b>{vItems.frekuensi}</b> 
						<span> x </span>
						<b>{vItems.dosis}</b>
						<span>{vItems.satuan_kecil||"pcs"}</span>
					</small>
					) : (
					<div style={{minWidth:150,width:"50%"}} className="text-end">
						{(uToggleditObj.jenis === "RESEPKETENTUAN" 
							&& parseInt(uToggleditObj.idxkey ?? "-1") === vKeys
						) ? (
						<>
							{(uToggleditObj.is_processing||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CForm>
							<CInputGroup size="sm">
								<CFormInput size="sm" type="number"
									className="text-end"
									value={uToggleditObj.frekuensi}
									onChange={(e)=>setToggleditObj({...uToggleditObj,frekuensi:e.target.value})}
									onKeyDown={(e)=>{
										if(e.keyCode === 27) {
											setToggleditObj({}); return;
										}
									}}
									onFocus={(e)=>e.target.select()}
									id="inpresepfrekuensi"/>
								<CInputGroupText className="px-">
									<small>x</small>
								</CInputGroupText>
								<CFormInput size="sm" type="number"
									className="text-end"
									value={uToggleditObj.dosis}
									onChange={(e)=>setToggleditObj({...uToggleditObj,dosis:e.target.value})}
									onKeyDown={(e)=>{
										if(e.keyCode === 27) {
											setToggleditObj({}); return;
										}

										if(e.keyCode !== 13) return;

										e.stopPropagation();e.preventDefault();
										hdlKlikToggleprosesresep();
									}}
									onFocus={(e)=>e.target.select()}
									id="inpresepdosis"/>
								<CInputGroupText className="bg-dark">
									<CLink onClick={()=>hdlKlikToggleprosesresep()} className="classcursorpointer text-white">
									<CIcon icon="cilCheck"/>
									</CLink>
								</CInputGroupText>
							</CInputGroup>
							</CForm>
							)}
						</>
						) : (
						<CLink onClick={()=>hdlKlikToggleeditresep('RESEPKETENTUAN',vKeys)} className="classcursorpointer ps-2">
						<small className="text-end">
							<b>{vItems.frekuensi}</b> 
							<span> x </span>
							<b>{vItems.dosis}</b>
							<span>{vItems.satuan_kecil||"pcs"}</span>
						</small>
						</CLink>
						)}
					</div>
					)}
				</div>

				{(vItems.aturan||"").trim() !== "" && (
				<div style={{minWidth:180,width:"90%"}} className="d-flex justify-content-between">
					<small>Aturan Tambahan</small>

					{vISstatusselesai ? (
					<div className="text-end">
						<i>{vItems.aturan}</i> 
					</div>
					) : (
					<div style={{minWidth:200,width:"65%"}} className="text-end">
						{(uToggleditObj.jenis === "RESEPATURAN" 
							&& parseInt(uToggleditObj.idxkey ?? "-1") === vKeys
						) ? (
						<>
							{(uToggleditObj.is_processing||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CInputGroup size="sm">
								<CFormInput size="sm" maxLength="255"
									value={uToggleditObj.value}
									onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
									onKeyDown={(e)=>{
										if(e.keyCode === 27) {
											setToggleditObj({}); return;
										}

										if(e.keyCode !== 13) return;

										e.stopPropagation();e.preventDefault();
										hdlKlikToggleprosesresep();
									}}
									id="inpresepaturan"/>
								<CInputGroupText className="bg-dark">
									<CLink onClick={()=>hdlKlikToggleprosesresep()} className="classcursorpointer text-white">
									<CIcon icon="cilCheck"/>
									</CLink>
								</CInputGroupText>
							</CInputGroup>
							)}
						</>
						) : (
						<CLink onClick={()=>hdlKlikToggleeditresep('RESEPATURAN',vKeys)} className="classcursorpointer ps-2">
							<i>{vItems.aturan}</i> 
						</CLink>
						)}
					</div>
					)}
				</div>
				)}
			</td>
			
			{!vISstatusselesai && (
			<td className="px-1 text-center">
				<CLink onClick={()=>hdlKlikResephapus(vKeys)} className="classikontabel classikonhapus classcursorpointer"/>
			</td>
			)}
			</tr>
			)//>
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//->

		return (
		<CForm>
		<CRow className="my-1">
			<CCol xs="4"><small>Diagnosa</small></CCol>
			<CCol className="text-end">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="--Pilih Diagnosa.."
					value={uDlgformObj.diagnosa}
					onChange={(e)=>setDlgformObj({...uDlgformObj,diagnosa: e.target.value})}
					id="inpdiagnosacaption"/>
				<CButton size="sm" color="dark" onClick={()=>hdlKlikDiagnosalookup()} id="btndiagnosalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="4"><small>Ket.Diagnosa</small></CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={255}
					value={uDlgformObj.diagnosa_ket}
					onChange={(e)=>setDlgformObj({...uDlgformObj,diagnosa_ket: e.target.value})}
					id="inpdiagnosaket"/>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="4"><small>Nomor Gigi</small></CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={255}
					value={uDlgformObj.ket_gigi}
					onChange={(e)=>setDlgformObj({...uDlgformObj,ket_gigi: e.target.value})}
					id="inpnomorgigi"/>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
			<CCol md="4"><small style={{color:"maroon"}}>Tindakan</small></CCol>
			<CCol className="text-end">
				<CFormTextarea size="sm"
					rows={5}
					value={UFunc.br2nl(uDlgformObj.tindakan_teks)}
					onChange={(e)=>setDlgformObj({...uDlgformObj,tindakan_teks: UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan",e)}
					id="inptindakan_teks"/>
			</CCol>
		</CRow>
		</CForm>
		)//->
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = () => {
		setHtml500msg();

		setDatamainObj({})
		setDataloading(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Rekammedisform - apiLoaddata) LEWAT ");
		let vTimeout = setTimeout(()=>{
			setLoading(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_rekammedis/ld_formedit";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setDataloading(false);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Rekammedisform - apiLoaddata) output_string.dataobject : "+output_string.dataobject);
				//setDataanamanseArr(JSON.parse(output_string.dataanamnase || "[]"));
				setDatamainObj(JSON.parse(output_string.dataobject || "{}"));
				setDatadiagnosaArr(JSON.parse(output_string.datadiagnosa || "[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Rekammedisform - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setDataloading(false);
			setLoading(false);
			console.log("(Rekammedisform - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProseseditmain = () => {
		//--CEK_JIKA_SAMA--/
		let vValuechecked;
		let vValue 			= uToggleditObj.value;
		if(uToggleditObj.jenis === "DIAGNOSAMAIN") {
			vValuechecked   = parseInt(uDatamainObj.diagnosa_main_id)||0;
			vValue 			= parseInt(uToggleditObj.value) || 0;
		} else if(uToggleditObj.jenis === "DIAGNOSAMAINTEKS") {
			vValuechecked = (uDatamainObj.diagnosa_main_teks || "").trim();
			vValue = (uToggleditObj.value || "").trim();
		} else if(uToggleditObj.jenis === "OBJECTIVE") {
			vValuechecked = (uDatamainObj.objective_teks || "").trim();
			vValue = (uToggleditObj.value || "").trim();
		} else if(uToggleditObj.jenis === "FORMOBJECTIVE") {
			vValuechecked = (uDatamainObj.objective_teks || "").trim();
			vValue = (uToggleditObj.value || "").trim();
		}

		if(vValuechecked === vValue) {
			//console.log("(Rekammedisform - apiProsesedititem) "+vValuechecked+" === "+vValue);
			setToggleditObj({});
			return;
		}
		//--END CEK_JIKA_SAMA--/

		let vElbutton = document.getElementById("btnDialogSimpan");
		vElbutton && (vElbutton.disabled = true);
		setToggleditObj({...uToggleditObj,is_processing:true});
		setLoading(true);
		 
		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_editpars : JSON.stringify(uToggleditObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_rekammedis/pr_editrmmain";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				if(uToggleditObj.jenis === "DIAGNOSAMAIN") {
					const vIdxdiagnosa	= UFunc.getObjectIndeks(uDatadiagnosaArr,uToggleditObj.value);
					setDatamainObj({
						...uDatamainObj,
						diagnosa_main_id: uToggleditObj.value,
						diagnosa_main: (uDatadiagnosaArr[vIdxdiagnosa]||{}).nama_diagnosa || "Undf Diagnosa",
					});
				} else if(uToggleditObj.jenis === "DIAGNOSAMAINTEKS") {
					setDatamainObj({
						...uDatamainObj,
						diagnosa_main_teks: (uToggleditObj.value||"").trim(),
					});
				} else if(uToggleditObj.jenis === "SUBJECTIVE") {
					const vSubjectiveObj = JSON.parse(uToggleditObj.value || "{}");

					setDatamainObj({
						...uDatamainObj,
						subjective_str: JSON.stringify(vSubjectiveObj),
						anamnase: vSubjectiveObj.anamnase_caption, 
						anamnase_id: vSubjectiveObj.anamnase_id,
					});
					uDispatch({type: "set", gDatasubjective: undefined});

					setDlgformsubjectiveshow(false);
				} else if(uToggleditObj.jenis === "OBJECTIVE") {
					setDatamainObj({
						...uDatamainObj,
						objective_teks: (uToggleditObj.value||"").trim(),
					});
				} else if(uToggleditObj.jenis === "FORMOBJECTIVE") {
					const vObjectiveObj = JSON.parse(uToggleditObj.value || "{}");

					setDatamainObj({
						...uDatamainObj,
						objective_str: JSON.stringify(vObjectiveObj),
					});
					uDispatch({type: "set", gDataobjective: undefined});

					setDlgformobjectiveshow(false);
				} 
				setToggleditObj({});
			} else if(output_string.expired) {
				setToggleditObj({});
				setLoading(true); prosesExpired(); return
			} else if(output_string.info) {
				if(uToggleditObj.jenis === "DIAGNOSAMAIN"
					){ setToggleditObj({}); }
				showToast(output_string.info);
			} else if(output_string.errors) {
				if(uToggleditObj.jenis === "DIAGNOSAMAIN"
					){ setToggleditObj({}); }
				console.log("(Rekammedisform - apiProseseditmain) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			if(uToggleditObj.jenis === "DIAGNOSAMAIN"
			) {
				setToggleditObj({});
			} else if(uToggleditObj.jenis === "DIAGNOSAMAINTEKS"
				|| uToggleditObj.jenis === "SUBJECTIVE"
				|| uToggleditObj.jenis === "OBJECTIVE"
				|| uToggleditObj.jenis === "FORMOBJECTIVE"
			) {
				setToggleditObj({...uToggleditObj,is_processing:undefined});
			}

			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Rekammedisform - apiProseseditmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesedititem = () => {
		const vInitplatform	= uToggleditObj.jenis===undefined ? "MOBILE" : "DESKTOP";
		let vTabelID	= vInitplatform==="MOBILE" ? parseInt(uDlgformObj.tabel_id ?? "0") : parseInt(uToggleditObj.tabel_id ?? "0");
		const vArridx	= UFunc.getObjectIndeks((uDatamainObj.items_arr||[]),vTabelID);

		const vElbutton	= document.getElementById("btnDialogSimpan");
		let vDatamobileObj	= {};
		let vValue;
		if(vInitplatform !== "MOBILE") {
			let vValuechecked;
			if(uToggleditObj.jenis === "KETGIGI") {
				vValue 			= (uToggleditObj.ket_gigi||"").trim().toUpperCase();
				vValuechecked = (((uDatamainObj.items_arr||[])[vArridx] || {}).ket_gigi || "").toUpperCase();
				setLoading(true);
			} else if(uToggleditObj.jenis === "TINDAKANTEKS") {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
				vValuechecked = (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_teks || "").toUpperCase();
			} else if(uToggleditObj.jenis === "TINDAKANCAPTION") {
				vValuechecked 	= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_id) || 0;
				vValue 			= parseInt(uToggleditObj.value) || 0;
			} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDER") {
				vValuechecked 	= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_id) || 0;
				vValue 			= parseInt(uToggleditObj.value) || 0;
			} else {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
			}

			if(vValuechecked === vValue) {
				//console.log("(Rekammedisform - apiProsesedititem) "+vValuechecked+" === "+vValue);
				setToggleditObj({});
				setLoading(false);
				return;
			}
		} else {
			vDatamobileObj	= {...uDlgformObj,
				dlg_header: undefined,
			}
			vElbutton && (vElbutton.disabled = true);
			setLoading(true);
		}
		setToggleditObj({...uToggleditObj,is_processing:true}); 

		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_editpars: JSON.stringify({
				jenis: uToggleditObj.jenis,
				value: vInitplatform!=="MOBILE" ? vValue : vDatamobileObj,
				nomorgigi_arr: uToggleditObj.jenis==="KETGIGI" ? JSON.parse(uToggleditObj.value||"[]") : undefined,
				tabel_id: vInitplatform!=="MOBILE" ? uToggleditObj.tabel_id : uDlgformObj.tabel_id,
				platform: vInitplatform,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_rekammedis/pr_editrmitem";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setToggleditObj({...uToggleditObj,is_processing:false});
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				if(vInitplatform !== "MOBILE") {
					let vTmpObj = {};
					if(uToggleditObj.jenis === "TINDAKANCAPTION"){
						(uDatamainObj.items_arr||[])[vArridx] = {
							...((uDatamainObj.items_arr||[])[vArridx] || {}),
							tindakan_id: uToggleditObj.value,
							tindakan_caption: uToggleditObj.value_caption || (uDatamainObj.items_arr||[])[vArridx].tindakan_caption,
						}
					} else if(uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS") {
						(uDatamainObj.items_arr||[])[vArridx] = {
							...((uDatamainObj.items_arr||[])[vArridx] || {}),
							tindakan_id: 0,
							tindakan_caption: null,
						}
					} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"){
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_id = uToggleditObj.value; 
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_caption = 
							uToggleditObj.value_caption || (uDatamainObj.items_arr||[])[vArridx].diagnosa_caption;
					} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS") {
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_id 		= 0; 
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_caption 	= "";
					} else if(uToggleditObj.jenis === "KETGIGI") {
						console.log("(Rekammedisform - apiProsesedititem) uToggleditObj.value",uToggleditObj.value);
						(uDatamainObj.items_arr||[])[vArridx] = {
							...((uDatamainObj.items_arr||[])[vArridx] || {}),
							ket_gigi: uToggleditObj.ket_gigi, 
							nomorgigiarr_str: uToggleditObj.value,
						}
						setDlgnomorgigiObj({...uDlgnomorgigiObj,
							nomorgigi_arr: JSON.parse(uToggleditObj.value||"[]"),
							is_updated: !(uDlgnomorgigiObj.is_updated||false),
						});//-*/

						vTmpObj = {...uToggleditObj};
					} else if(uToggleditObj.jenis === "KETGIGIHAPUS") {
						(uDatamainObj.items_arr||[])[vArridx] = {
							...((uDatamainObj.items_arr||[])[vArridx] || {}),
							ket_gigi: null,
							nomorgigiarr_str: null,
						}
					} else if(uToggleditObj.jenis === "TINDAKANTEKS") {
						(uDatamainObj.items_arr||[])[vArridx].tindakan_teks =
							(uToggleditObj.value); 
					}

					setToggleditObj(vTmpObj);
				} else {
					(uDatamainObj.items_arr||[])[vArridx].tindakan_id 	= vDatamobileObj.tindakan_id;
					(uDatamainObj.items_arr||[])[vArridx].tindakan_caption 	= vDatamobileObj.tindakan_caption;
					(uDatamainObj.items_arr||[])[vArridx].ket_gigi 		= vDatamobileObj.ket_gigi;
					(uDatamainObj.items_arr||[])[vArridx].tindakan_teks = vDatamobileObj.tindakan_teks;

					setDlgformshow(false);
				}
			} else if(output_string.expired) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				setLoading(true); prosesExpired(); return
			} else if(output_string.info) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				showToast(output_string.info);
			} else if(output_string.errors) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }
				console.log("(Rekammedisform - apiProsesedititem) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			if(uToggleditObj.jenis === "TINDAKANCAPTION"
				|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
				|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
				|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
			) { 
				setToggleditObj({}); 
			} else setToggleditObj({...uToggleditObj,is_processing:false});

			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Rekammedisform - apiProsesedititem) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseseditresep = () => {
		const vInitplatform	= uToggleditObj.jenis===undefined ? "MOBILE" : "DESKTOP";
		const vArridx	= vInitplatform==="MOBILE" ? parseInt(uDlgformObj.idxkey) : parseInt(uToggleditObj.idxkey);

		const vElbutton			= document.getElementById("btnDialogSimpan");
		let vDataresepnewArr	= JSON.parse(uDatamainObj.reseparr_str||"[]");
		let vDatamobileObj;
		let vValue;
		if(vInitplatform !== "MOBILE") {
			let vISDatanotchanged = false;
			let vValuechecked;
			let vValue;
			if(uToggleditObj.jenis === "RESEPQTY") {
				vValue 			= parseFloat(vDataresepnewArr[vArridx].qty ?? "0");
				vValuechecked 	= parseFloat(uToggleditObj.value ?? "1");

				if(vValuechecked === vValue) vISDatanotchanged = true;
				else
					vDataresepnewArr[vArridx] = {
						...(vDataresepnewArr[vArridx]||{}),
						qty: vValuechecked,
					}
			} else if(uToggleditObj.jenis === "RESEPKETENTUAN") {
				vValue 			= parseFloat(vDataresepnewArr[vArridx].dosis ?? "0");
				vValuechecked 	= parseFloat(uToggleditObj.dosis ?? "1");

				const vFrekuensi = parseInt(uToggleditObj.frekuensi ?? "1")

				if(vValuechecked === vValue
					&& parseInt(vDataresepnewArr[vArridx].frekuensi ?? "1") === vFrekuensi
				) vISDatanotchanged = true;
				else
					vDataresepnewArr[vArridx] = {
						...(vDataresepnewArr[vArridx]||{}),
						frekuensi: vFrekuensi,
						dosis: vValuechecked,
					}
			} else if(uToggleditObj.jenis === "RESEPATURAN") {
				vValue 			= (vDataresepnewArr[vArridx].aturan || "").trim();
				vValuechecked 	= (uToggleditObj.value || "").trim();

				if(vValuechecked.toUpperCase() === vValue.toUpperCase()) vISDatanotchanged = true;
				else
					vDataresepnewArr[vArridx] = {
						...(vDataresepnewArr[vArridx]||{}),
						aturan: vValuechecked,
					}
			} else if(uToggleditObj.jenis === "RESEPHAPUS") {
				vDataresepnewArr.splice(vArridx,1);
			} else {
				vISDatanotchanged = true;
			}

			if(vISDatanotchanged) {
				setToggleditObj({});
				return;
			}
		} else {
			vDatamobileObj	= {...uDlgformObj,
				dlg_header: undefined,
			}
			vElbutton && (vElbutton.disabled = true);
			setLoading(true);
		}
		setToggleditObj({...uToggleditObj,is_processing:true}); 

		//console.log("(Rekammedisform - apiProsesedititem) uToggleditObj === "+JSON.stringify(uToggleditObj));
		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_editpars : JSON.stringify({...uToggleditObj,
				resep_arr: vDataresepnewArr,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_rekammedis/pr_editrmmain";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setToggleditObj({...uToggleditObj,is_processing:false});
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				setDatamainObj({...uDatamainObj,
					reseparr_str: JSON.stringify(vDataresepnewArr),
				})
				setToggleditObj({});
				setDlgformshow(false);
			} else if(output_string.expired) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				setLoading(true); prosesExpired(); return
			} else if(output_string.info) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				showToast(output_string.info);
			} else if(output_string.errors) {
				if(uToggleditObj.jenis === "TINDAKANCAPTION"
					|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }
				console.log("(Rekammedisform - apiProseseditresep) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			if(uToggleditObj.jenis === "TINDAKANCAPTION"
				|| uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS"
				|| uToggleditObj.jenis === "DIAGNOSASEKUNDER"
				|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
			) { 
				setToggleditObj({}); 
			} else setToggleditObj({...uToggleditObj,is_processing:false});

			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Rekammedisform - apiProseseditresep) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiKirimsatusehat = () => {
		const vTabelID 			= parseInt(uDatamainObj.id_progress)||0; if(vTabelID <= 0) return;
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadTokensatusehat(apiKirimsatusehat); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadTokensatusehat(apiKirimsatusehat); return;
		}

		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);

			initFormawal();
			showToast(uBahasaObj.pesan_sukses,"SUKSES")
		},2000); return;//--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelID,
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_statuspasien/pr_kirimsatusehat";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				const vIHSmessage 	= output_string.ihs_message || "";

				setDatamainObj({...uDatamainObj,satusehat_status:"SUDAH"});
				if(vIHSmessage !== "")
					showToast("SATUSEHAT: <b>"+vIHSmessage+"</b>","SUKSES");

				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Rekammedisform - apiProsessatusehat) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Rekammedisform - apiProsessatusehat) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}

	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoaddata();

		return () => {
			setDatamainObj({}); setDatadiagnosaArr([]); setDataanamanseArr([]);
			setToggleditObj({});
			setTriggeredit(false);
			setDlgformshow(false);setDlglookupshow(false);setDlgnomorgigishow(false);
			setDlgformsubjectiveshow(false);setDlgformobjectiveshow(false);
			uDispatch({type: "set", gDatasubjective: undefined});
			uDispatch({type: "set", gDataobjective: undefined});
		}
	},[])
	React.useEffect(()=>{
		if(!uTriggeredit) return;

		setTriggeredit(false);

		if(uToggleditObj.jenis==="RESEPHAPUS") {
			apiProseseditresep();
			return;
		}

		if((parseInt(uToggleditObj.tabel_id)||0) > 0) {
			apiProsesedititem();
			return;
		}

		apiProseseditmain();
	},[uTriggeredit]);
	React.useEffect(()=>{
		if(!uISDlgformshow) 
			{ setDlgformObj({}); return }
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlglookupshow) { 
			if((uDlglookupObj.init_selected||false)!==true) setToggleditObj({})
			setDlglookupObj({});
			return 
		}
	},[uISDlglookupshow]);
	React.useEffect(()=>{
		if(!uISDlglookupapishow) {
			if((uDlglookupapiObj.init_selected||false)!==true) setToggleditObj({})
			setDlglookupapiObj({}); 
			return
		}
	},[uISDlglookupapishow]);
	React.useEffect(()=>{
		if(!uISDlgformsubjectiveshow && !uISDlgformsubjectivesimpan)
			{ setToggleditObj({}); return }
	},[uISDlgformsubjectiveshow]);
	React.useEffect(()=>{
		if(!uISDlgformsubjectivesimpan) return;
		uDispatch({type: "set", gISSubjectivesimpan: undefined});

		setToggleditObj({...uToggleditObj,
			value: JSON.stringify(uDatasubjectiveObj),
		})

		//console.log("(Rekammedisform) uDatasubjectiveObj => "+JSON.stringify(uDatasubjectiveObj))
		setTriggeredit(true);
	},[uISDlgformsubjectivesimpan]);
	React.useEffect(()=>{
		if(!uISDlgformobjectiveshow && !uISDlgformobjectivesimpan)
			{ setToggleditObj({}); return }
	},[uISDlgformobjectiveshow]);
	React.useEffect(()=>{
		if(!uISDlgformobjectivesimpan) return;
		uDispatch({type: "set", gISObjectivesimpan: undefined});

		setToggleditObj({...uToggleditObj,
			value: JSON.stringify(uDataobjectiveObj),
		})
		setTriggeredit(true);
	},[uISDlgformobjectivesimpan]);
	React.useEffect(()=>{
		if(!uISDlgnomorgigishow) {
			setDlgnomorgigiObj({});
			setToggleditObj({});
			return;
		}
	},[uISDlgnomorgigishow]);

	//---END EFFECT--/

	//console.log("(Rekammedisform) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Edit Rekam Medis</b>
			</CHeaderBrand>

			{(!uDataloading && !uHtml500msg) && (
			<>
			{((uDatamainObj.waktu_selesai||"")!=="") && (
			<>
				{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" ? (
				<CHeaderNav className="">
				<CButton size="sm" color="light"
					className="px-3 fw-bolder border-dark"
					onClick={()=>hdlKlikKirimsatusehat()}
					id="btnKirimSS">
					<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} className="me-md-2" height={25}/>
					<span className="d-none d-md-inline">Kirim Satusehat</span>
				</CButton>
				</CHeaderNav>
				) : (
				<CBadge color="light" className="border border-success">
					<CIcon icon="cilCheckAlt" className="align-middle me-1 text-success" height={23}/>
					<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} height={20}/>
				</CBadge>
				)}
			</>
			)}
			</>
			)}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard my-4">
				<CCardHeader className="d-flex justify-content-between align-items-center">
					<div>Error Page 500</div>
					<CLink onClick={apiLoaddata} className="classcursorpointer classikon classikonreset"/>
				</CCardHeader>
				<CCardBody>
					<div className="m-lg-5">{UFunc.renderHTML(uHtml500msg)}</div>
				</CCardBody>
			</CCard>
			) : (
			<>
				{uDataloading ? (
				<CCard className="classbgcard mb-3">
					<CCardBody className="text-primary text-center py-md-5">
						<span className="classblinking">Loading..</span>
					</CCardBody>
				</CCard>
				) : (
				<>
				<CRow className="align-items-stretch">
				<CCol md="6" lg="5" className="mb-3">
					<CCard className="classbgcard h-100">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small>Data RM</small>
					</CCardHeader>
					<CCardBody>
						{contentTanggal()}
						<div className="my-2 classborderbottom"/>
						{contentDokter()}
					</CCardBody>
					</CCard>
				</CCol>

				<CCol className="mb-3">
					<CCard className="classbgcard h-100">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small>Perawat</small>
					</CCardHeader>

					<CCardBody className="text-center">{contentPerawat()}</CCardBody>
					</CCard>
				</CCol>
				</CRow>

				<CRow className="align-items-stretch">
				<CCol md="6" lg="4" className="mb-3">
					<CCard className="classbgcard h-100">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small><b>(S)</b>ubjective</small>
					</CCardHeader>
					<CCardBody className="text-center">{contentSubjective()}</CCardBody>
					</CCard>
				</CCol>

				<CCol md="6" lg="4" className="mb-3">
					<CCard className="classbgcard h-100">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small><b>(O)</b>bjective</small>
					</CCardHeader>
					<CCardBody className="text-center">{contentObjective()}</CCardBody>
					</CCard>
				</CCol>

				<CCol className="mb-3">
					<CCard className="classbgcard h-100">
						<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
							<b>(A)</b><small>ssesment</small>
						</CCardHeader>
						<CCardBody>{contentDiagnosamain()}</CCardBody>
					</CCard>
				</CCol>
				</CRow>

				<CRow className="">
				<CCol>
					{contentItem()} 
				</CCol>

				<CCol lg="5" className="mb-3">
					<CCard className="classbgcard h-100">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small>Resep Obat</small>
					</CCardHeader>

					<CCardBody className="px-0">{contentResep()}</CCardBody>
					</CCard>
				</CCol>
				</CRow>
				</>
				)}
			</>
			)}
		</CContainer>
		</div>		
		</div>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.lookup_arr||[]} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialoglookupapi
			show={uISDlglookupapishow}
			toggle={()=>setDlglookupapishow(false)}
			dialogHeader={uDlglookupapiObj.dlg_header||""}
			inputValue={uDlglookupapiObj.dlg_keyword}
			onKlikPilihItem={hdlKlikPilihLookupapi}
			targetApi={uDlglookupapiObj.dlg_targetapi||""} 
			kdownTrigger={uDlglookupapiObj.dlg_trigger}
			id="iddialoglookupapi"
			{...props}/>

		<MyDialogform
			options={{centered:true,size:"lg"}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow}
			dialogHeader={uDlgformObj.dlg_header||""}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialogformsubjective
			showDlg={uISDlgformsubjectiveshow}
			toggleShow={()=>setDlgformsubjectiveshow(false)}
			{...props}/>

		<MyDialogformobjective
			showDlg={uISDlgformobjectiveshow}
			toggleShow={()=>setDlgformobjectiveshow(false)}
			{...props}/>

		<MyDialognomorgigi
			showDlg={uISDlgnomorgigishow} 
			toggleShow={()=>setDlgnomorgigishow(false)}
			dataSelectedArr={uDlgnomorgigiObj.nomorgigi_arr || []} 
			onKlikpilih={hdlKlikNomorgigipilih}
			isUpdated={uDlgnomorgigiObj.is_updated}
			{...props}/>
		</>
	)//>
}	

export default Rekammedisform